import axios from 'axios';

class TaskServiceClass{
  constructor(){
    this.url = 'https://plameet.com';
    this.apiUrl = 'https://plameet.com/api/v1';
  }

  createTask({onSucess=null, onError=null, taskData=null}){
    axios.post(`${this.apiUrl}/tasks`, 
      {task: taskData},
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  updateTask({onSucess=null, onError=null, taskId=null, taskData=null}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/update`,
      {task: taskData},
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  playTask({onSucess=null, onError=null, taskId=null}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/play`, 
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  timesUpTask({onSucess=null, onError=null, taskId=null}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/times_up`, 
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  listInstanceTask({onSucess=null, onError=null, date=null}){
    axios.get(`${this.apiUrl}/tasks/list_instances?date=${JSON.stringify(date)}`,
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  deleteTask({onSucess=null, onError=null, taskId=null}){
    axios.delete(`${this.apiUrl}/tasks/${taskId}`, 
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  archiveTask({onSucess=null, onError=null, taskId=null}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/archive`, 
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  unarchiveTask({onSucess=null, onError=null, taskId=null}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/unarchive`, 
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  finishTask({onSucess=null, onError=null, taskId=null, elapsedTime=0}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/finish`,
      {
        task: {
          elapsed_time: elapsedTime
        }
      },
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  addTagTask({onSucess=null, onError=null, taskId=null, tagId}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/add_tag`,
      {
        task: {
          tag_id: tagId
        }
      },
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
  removeTagTask({onSucess=null, onError=null, taskId=null, tagId}){
    axios.patch(`${this.apiUrl}/tasks/${taskId}/delete_tag`,
      {
        task: {
          tag_id: tagId
        }
      },
      {crossdomain: true, headers: {}}
    ).then(onSucess).catch(onError)
  }
}

export const TaskService = new TaskServiceClass();
